/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Saturday, 23rd March 2019
 *
 *  Notification Bar: Can accept multiple styles and has a close button option.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

// Material UI Components
import { SnackbarContent } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { green, amber, blue } from '@material-ui/core/colors';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  primary: InfoIcon,
  secondary: InfoIcon,
};

class SubscribeNotifier extends React.Component {
  render() {
    const {
      classes,
      className,
      message,
      messagePrefix,
      onClose,
      icon,
      variant,
      open,
      actionButtonClick,
      ...rest
    } = this.props;
    const Icon = variantIcon[variant];
    // Check Variant
    if (variant)
      return (
        <SnackbarContent
          className={classNames(classes[variant], className)}
          classes={{
            root: classes.root,
            action: classes.action,
            message: classes.message,
          }}
          message={
            <div className={classes.flex}>
              {Icon !== undefined ? <Icon className={classNames(classes.icon, classes.iconVariant)} /> : null}
              <span>
                <strong className={classes.prefix}>{messagePrefix}</strong>
                {message}
              </span>
            </div>
          }
          action={[
            <Button variant='contained' onClick={actionButtonClick}>
              Subscribe
            </Button>,
          ]}
          {...rest}
        />
      );
  }
}

SubscribeNotifier.defaultProps = {
  variant: 'info',
};

SubscribeNotifier.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  messagePrefix: PropTypes.node,
  message: PropTypes.node,
  actionButtonClick: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'primary', 'secondary']).isRequired,
};

const styles = theme => ({
  root: {
    flexWrap: 'unset',
    position: 'relative',
    lineHeight: '20px',
    fontSize: '14px',
    borderRadius: '4px',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  prefix: {
    padding: '0px 5px 0px 0px ',
  },
  message: {
    padding: '0',
    display: 'block',
    maxWidth: '90%',
  },
  iconButton: {
    width: '24px',
    height: '24px',
    padding: theme.spacing(1),
  },
  close: {
    width: '15px',
    height: '15px',
  },
  fullWidth: {
    width: '100%',
    paddingRight: theme.spacing(1),
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
    //marginBottom: '0',
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.type === 'light' ? theme.palette.text.primary.dark : theme.palette.text.primary,
  },
  secondary: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.type === 'light' ? theme.palette.text.primary.dark : theme.palette.text.primary,
  },
  info: {
    backgroundColor: blue[400],
  },
  success: {
    backgroundColor: green[400],
  },
  warning: {
    backgroundColor: amber[400],
    color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.primary.light,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.type === 'light' ? theme.palette.text.primary.dark : theme.palette.text.primary,
  },
});

export default withStyles(styles, { withTheme: true })(SubscribeNotifier);
